import { render, staticRenderFns } from "./GreenDesignProducts.vue?vue&type=template&id=c7d4e288&scoped=true&"
import script from "./GreenDesignProducts.vue?vue&type=script&lang=js&"
export * from "./GreenDesignProducts.vue?vue&type=script&lang=js&"
import style0 from "./GreenDesignProducts.vue?vue&type=style&index=0&id=c7d4e288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d4e288",
  null
  
)

export default component.exports